/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum UserTrackingAction {
    VIEW_GAME = 'VIEW_GAME',
    GEN_AI_STORY = 'GEN_AI_STORY',
    GOTO_STUDIO = 'GOTO_STUDIO',
    COMPLETE_GAME = 'COMPLETE_GAME',
    GEN_OUTLINE = 'GEN_OUTLINE',
    GEN_ASSETS = 'GEN_ASSETS',
    EDIT_STUDIO = 'EDIT_STUDIO',
    CREATE_AI_STORY = 'CREATE_AI_STORY',
}
